import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import {useSelector} from "react-redux";


const RequireAuthRoute = ({ component: Component, authenticated, ...rest }) => {
  // console.log("Component",Component)
    const {onboardRequired}=useSelector(state=>state.auth)
  return (
    <Route
      {...rest}
      render={props => {
        return authenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={{
            pathname: '/',
            state: { from: props.location }
          }} />
        )
      }}
    />
  )
};


export default RequireAuthRoute;
